<template>
    <div>
        <div class="display-flex display-flex-space-between margin-top-20">
            <FilterExcersice class="flex-left" @handleSeach="handleSeach" />
            <div class="wrap-right display-flex justify-content-end flex-right">

                <a href="javascript:;" class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                    @click="handleCreateExcercise">
                    <img class="icon-plus" src="@/assets/img/plus.png" />
                    <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                    Tạo bài tập/bài kiểm tra mới
                </a>
            </div>
        </div>
        <div class="" v-if="listDataExcerciseAssign.length > 0">
            <div class="row header">
                <div class="col-md-3">
                    Tên đề
                </div>
                <div class="col-md-3">
                    Loại đề
                </div>
                <div class="col-md-3">
                    Khối
                </div>
                <div class="col-md-3">
                    Môn
                </div>
            </div>
            <div class="row list-excercise" v-for="(item, index) of listDataExcerciseAssign" :key="index">
                <div class="col-md-3">
                    <router-link
                        :to="{ path: '/de-thi-da-giao', query: { lessonId: item.id, examId: item.examId, name: item.name } }"
                        target="_blank">
                        {{ item.name }}
                    </router-link>
                </div>
                <div class="col-md-3">
                    {{ item.typeExcerciseName }}
                </div>
                <div class="col-md-3">
                    {{ item.className }}
                </div>
                <div class="col-md-3">
                    {{ item.subjectName }}
                </div>
            </div>
        </div>
        <div class="" v-else style="text-align: center;"> Bài tập/bài kiểm tra đang giao không có dữ liệu </div>
        <div class="row pagination container m-0">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>
    </div>
</template>
<script>
import FilterExcersice from './_components/FilterExcersice'
import { getListExcerciseAssign } from './../../_api/LessonClassSchoolServices'

export default {
    components: {
        FilterExcersice
    },
    watch: {
        'paramQueryData.pageIndex': 'getListDataExcercise',
        //'paramQueryData.keyword': 'filterDataByKeyword'
    },
    data() {
        return {
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                type: 3,
                pageSize: 10,
                subjectId: 0,
                classId: 0,
                typeExcercise: 0,
            },
            listDataExcerciseAssign: [],
            totalRecords: 0
        }
    },
    mounted() {
        this.getListDataExcercise()
    },
    methods: {
        handleSeach(filter) {
            this.paramQueryData.keyword = filter.keyword,
                this.paramQueryData.subjectId = filter.subjectId,
                this.paramQueryData.classId = filter.classId
            this.paramQueryData.typeExcercise = filter.typeExcercise

            this.paramQueryData.pageIndex = 1
            this.getListDataExcercise()
        },
        handleCreateExcercise() {
            const routeData = this.$router.resolve({ path: '/tao-bai-kiem-tra' });
            window.open(routeData.href, '_blank');
        },
        filterDataByKeyword() {
            this.paramQueryData.pageIndex = 1
            this.getListDataExcercise()
        },
        getListDataExcercise() {
            let self = this
            getListExcerciseAssign(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataExcerciseAssign = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.justify-content-end {
    justify-content: end;
}

.flex-left {
    flex: 2;
}

.flex-right {
    flex: 1;
}

.margin-top-20 {
    margin-top: 20px;
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.display-flex-space-between {
    justify-content: space-between;
}

.btn-delete {
    color: white;
    background: #fe0201;
    padding: 5px 20px 5px 20px;
    border-radius: 15px;
    font-family: sans-serif;
}
</style>